import "firebase/compat/firestore"
import { db } from "../firebase"
import { toast } from "react-toastify"
import firebase from "firebase/compat/app"
import Send from "../communication"
import { sort } from "fast-sort"

export const getHistoryMessages = async (chatId) => {
  const getGroups = async (groups) => {
    let formattedMessages = []

    console.log({ groups })

    formattedMessages = await Promise.all(
      groups.map(async (groupId) => {
        try {
          const docSnapshot = await db.collection("groups").doc(groupId).get()

          if (docSnapshot.exists) {
            let data = docSnapshot.data()

            if (data.users.length === 2) {
              const messagesSnapshot = await db
                .collection("groups")
                .doc(groupId)
                .collection("messages")
                .get()
              const messages = messagesSnapshot.docs.map((doc) => doc.data())

              return messages
            }
          } else {
            return []
          }
        } catch (error) {
          console.log("Error to fetch group or messages collection", error)
          return []
        }
      }),
    )
      .then((items) => items.flat())
      .then((items) => items.filter((item) => item))

    console.log({ formattedMessages })

    formattedMessages = sort(formattedMessages).desc((u) => new Date(u.date * 1000))

    return formattedMessages
  }

  const formattedMessages = await toast.promise(
    Send.get(`/projects/groups/user/${chatId}`).then((groups) => getGroups(groups)),
    {
      pending: "Buscando mensagens antigas",
      success: "Sucesso",
      error: "Não foi possível buscar o histórico do usuário",
    },
  )

  return formattedMessages
}

export const getSystemMessages = async (chatId) => {
  let messages = [];

  try {
    const result = await db
      .collection(`users/${chatId}/messages`)
      .where('from', '==', "system_chat")
      .orderBy("from")
      .orderBy("date", "desc")
      .get();

    result.forEach((doc) => {
      messages.push(doc.data());
    });
  } catch (error) {
    messages = [];
    console.log("Error -> ", error);
  }

  return messages;
}

export const getChatById = async (chatId) => {
  let chat = null;

  try {
    chat = await db.collection("users").doc(chatId).get();

    if (chat.exists) {
      chat = chat.data();
    }
  } catch (error) {
    console.log("error => ", error);
  }

  return chat;
}

export const getMessages = (chatId, onMessage, onUpdate, onError, isSystemChat = false) => {
  let subscription = db
    .collection(`users/${chatId}/messages`)

  if (isSystemChat) {
    subscription = subscription
      .where('from', '==', "system_chat")
      .orderBy("from")
  } else {
    subscription = subscription
      .where('from', '!=', "system_chat")
      .orderBy("from")
  }

  subscription = subscription
    .orderBy("date", "desc")
    .onSnapshot((querySnapshot) => {
      const next = []
      querySnapshot.docChanges().forEach((change) => {
        let data = change.doc.data();
        let parentCollection = change.doc.ref.parent.path;

        data.id = change.doc.id;

        if (parentCollection === `users/${chatId}/messages`) {
          if (change.type === "added") {
            next.push(data);
          }
          if (change.type === "modified") {
            onUpdate(data);
          }
        }
      })

      onMessage(next)
    }, onError)

  return subscription
}

export const markGroupAsRead = async (userId, chatId) => {
  try {
    await db
      .collection(`users`)
      .doc(chatId)
      .update({
        "latestMessage.readByUsers": firebase.firestore.FieldValue.arrayUnion(userId),
      })
      .catch((e) => console.log("Error to mark message as read (message collection)"))

    const querySnapshot = await db
      .collection(`users/${chatId}/messages`)
      .orderBy("date", "desc")
      .limit(1)
      .get()

    if (!querySnapshot.empty) {
      const lastMessageDoc = querySnapshot.docs[0]
      await lastMessageDoc.ref.update({
        readByUsers: firebase.firestore.FieldValue.arrayUnion(userId),
      })

      console.log("Última mensagem marcada como lida")
    } else {
      console.log("Nenhuma mensagem encontrada")
    }
  } catch (e) {
    console.log("Erro ao marcar a mensagem como lida:", e)
  }
}

export const addingIsFinished = async (chatId, isFinished = true) => {
  await db
    .collection(`users`)
    .doc(chatId)
    .update({
      isFinished,
    })
    .catch((e) => console.log("Error to mark message as read (message collection)"))
}

export const getSystemAnswer = async (chat, message, context) => {
  try {
    const response = await Send.post("/ia/ask", {
      question: message,
      context
    });

    const answer = response?.message?.content;

    putMessage(chat,
      { id: 'system_chat_id', name: "Assistente de impacto", email: "" },
      answer ? answer : "Desculpe, não consegui encontrar um resposta :(",
      null,
      chat?.users,
      chat?.name,
      null,
      null,
      null,
      true
    );
  } catch (error) {
    console.log("Error -> ", error);
  }
}

export const putMessage = (
  chat,
  user,
  message,
  attachment = null,
  users = [],
  groupName,
  news = null,
  needwait = false,
  reference,
  isSystemChat = false,
  resend = null,
  templateId,
  favorited = null,
  instanceName = null
) => {
  const batch = db.batch()

  const messageRef = reference ? reference : db.collection(`users/${chat.id}/messages`).doc()
  const id = messageRef.id

  const extraProps = {}

  if (attachment) {
    extraProps["attachment"] = attachment
  }

  if (news) {
    extraProps["news"] = news
  }

  if (isSystemChat) {
    extraProps["hasEvaluation"] = true;
    extraProps["from"] = 'system_chat';
  }

  if (instanceName) {
    extraProps["instanceName"] = instanceName;
  }

  console.log("EXTRAPROPS -> ", { extraProps, isSystemChat })

  batch.set(messageRef, {
    id,
    content: message,
    user: user.id,
    userName: user.name,
    userEmail: user.email,
    date: firebase.firestore.Timestamp.now(),
    serverDate: firebase.firestore.Timestamp.now(),
    from: "",
    resend: resend && resend,
    favorited: favorited || null,
    templateId: templateId || '',
    instanceName: instanceName || null,
    // project: chat.projectId,
    // projectName: chat.projectName,
    needwait,
    ...extraProps,
  })

  if (!isSystemChat) {
    const chatRef = db.collection("users").doc(chat.id)

    batch.update(chatRef, {
      latestMessage: {
        id,
        user: user.id,
        userName: user.name,
        userEmail: user.email,
        date: firebase.firestore.Timestamp.now(),
        content: message,
        from: "Impactools",
        templateId: templateId || '',
        resend: resend && resend,
        favorited: favorited || null,
        instanceName: instanceName || null,
        // project: chat.projectId,
        // projectName: chat.projectName,
      },
    })
  }

  batch
    .commit()
    .then(() => {
      !isSystemChat && sendNotification(chat.id, user.name, message);
      console.log("Message added with success")
    })
    .catch((e) => console.log(e))
}

export const putMessageAsync = async (
  chat,
  user,
  id,
  message,
  date,
  serverDate,
  attachment = null,
  needwait = false,
  favorited = null,
  instanceName = null
) => {
  const batch = db.batch();
  const messageRef = db.collection(`users/${chat.id}/messages`).doc(id)
  const messageRefId = messageRef.id;

  const extraProps = {};

  if (attachment) {
    extraProps["attachment"] = attachment;
  }

  const messageData = {
    id: messageRefId,
    content: message,
    user: user.id,
    userName: user.name,
    userEmail: user.email,
    date,
    serverDate,
    from: "Impactools",
    favorited: favorited || null,
    templateId: '',
    instanceName: instanceName || null,
    needwait,
    ...extraProps,
  }

  batch.update(messageRef, messageData);

  try {
    await batch.commit();
    return { success: true, message: "Message added with success" };
  } catch (e) {
    console.error(e);
    return { success: false, error: e.message || "Failed to add message" };
  }
}

export const getChats = async (loggedUser, read, lastChatId = null) => {
  let data = [];
  const isAdmin = loggedUser && loggedUser.roles?.role === "USER_ADMIN";
  const projectList = loggedUser?.projectUser?.map((row) => row?.project).filter((row) => row) || [];
  
  console.log('🔍 getChats called with:', {
    loggedUserId: loggedUser?.id,
    isAdmin,
    projectUserLength: loggedUser?.projectUser?.length,
    projectList: projectList,
    read
  });

  try {
    if (loggedUser && loggedUser.id) {
      console.log("instance", loggedUser?.instance)
      let query = db.collection("users").where('instance', '==', loggedUser?.instance)
        .orderBy('latestMessage.date', "desc")

      if (read && !lastChatId) {
        query = query.limit(50);
      }

      console.log({ loggedUser })

      if (!isAdmin) {
        const projectIds = projectList.map((row) => row?.id)
        const chunkSize = 10

        const chunkArray = (array, size) =>
          array.reduce((acc, _, i) => (i % size ? acc : [...acc, array.slice(i, i + size)]), [])

        const projectChunks = chunkArray(projectIds, chunkSize)
        console.log("PROJECT IDS", { projectIds })

        const processChunk = async (chunk) => {
          // let tempQuery = query.where("projectIds", "array-contains-any", chunk);
          let tempQuery = query.where("companies", "array-contains", loggedUser?.external_data?.empresa?.id)
          if (!read) {
            tempQuery = tempQuery.where("isFinished", "==", false);
          }

          if (read && !lastChatId) {
            tempQuery = tempQuery.limit(20);
          }

          return tempQuery.get().then((querySnapshot) =>
            querySnapshot.docs
              .map((document) => {
                const data = document.data()
                return { ...data, id: document.id }
              })
              .filter((item) => item && (!read || read && (item.isFinished === undefined || item.isFinished === true))),
          )
        }

        const allResults = await Promise.all(projectChunks.map(processChunk))
        data = allResults.flat()
      } else {
        if (!read) {
          query = query.where("isFinished", "==", false)
        }

        data = await query.get().then((querySnapshot) => {
          const chats = querySnapshot.docs
            .map((document) => {
              const data = document.data()
              return { ...data, id: document.id }
            })
            .filter((item) => item && (!read || read && (item.isFinished === undefined || item.isFinished === true)))

          return chats
        })
      }
      
      // Remove duplicates based on ID to avoid issues with overlapping chunks
      const uniqueChats = data.reduce((acc, current) => {
        const existing = acc.find(item => item.id === current.id)
        if (!existing) {
          acc.push(current)
        }
        return acc
      }, [])
      
      data = uniqueChats
    }
  } catch (error) {
    console.error("Error fetching chats from Firebase:", error);
  }

  console.log(`Fetched ${data.length} chats from Firebase`)

  return data;
}

const countNewMessagesFromOthers = (userId, data) => {
  return data.latestMessage && data.latestMessage.content && data.latestMessage.user === userId
    ? 0
    : 1
}

export const getOrCreateChat = async (params, userId, projectId) => {
  // let chat = await getSpecificChat(params.id, userId)
  // if(chat && chat?.users.length > 1) {
  //     return chat;
  // }
  // return false
}

export const sendNotification = (chatId, username, message) => {
  let headers = {
    "Content-Type": "application/json; charset=utf-8",
    Authorization: `Basic '${token}'`,
  }

  let include_external_user_ids = [chatId]
  let endpoint = "https://onesignal.com/api/v1/notifications"
  let params = {
    method: "POST",
    headers: headers,
    body: JSON.stringify({
      app_id,
      data: { chatId },
      headings: { en: username, pt: username },
      contents: { en: message, pt: message },
      android_group: chatId,
      thread_id: chatId,
      include_external_user_ids,
      large_icon: "ic_launcher_round",
      ios_badgeType: "Increase",
      ios_badgeCount: 1,
    }),
  }

  fetch(endpoint, params)
    .then((res) => res.json())
    .then((res) => console.log(res))
}
const token = "MzUwYmY1MjYtZmQwNS00MTJhLWE1MDMtZWI0NDI4N2RiZGMz"
const app_id = "6ceb22ed-2e93-44b3-a6b0-ee8dcd26478a"
